/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TariffInfoDto } from './tariff-info-dto';
import {
    TariffInfoDtoFromJSON,
    TariffInfoDtoFromJSONTyped,
    TariffInfoDtoToJSON,
    TariffInfoDtoToJSONTyped,
} from './tariff-info-dto';

/**
 * 
 * @export
 * @interface FinalOrderRoomInfoDto
 */
export interface FinalOrderRoomInfoDto {
    /**
     * Название номера
     * @type {string}
     * @memberof FinalOrderRoomInfoDto
     */
    name: string;
    /**
     * 
     * @type {TariffInfoDto}
     * @memberof FinalOrderRoomInfoDto
     */
    tariff: TariffInfoDto;
    /**
     * Контрольная сумма
     * @type {string}
     * @memberof FinalOrderRoomInfoDto
     */
    checksum: string;
    /**
     * RoomType ID
     * @type {string}
     * @memberof FinalOrderRoomInfoDto
     */
    roomTypeId: string;
}

/**
 * Check if a given object implements the FinalOrderRoomInfoDto interface.
 */
export function instanceOfFinalOrderRoomInfoDto(value: object): value is FinalOrderRoomInfoDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tariff' in value) || value['tariff'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    if (!('roomTypeId' in value) || value['roomTypeId'] === undefined) return false;
    return true;
}

export function FinalOrderRoomInfoDtoFromJSON(json: any): FinalOrderRoomInfoDto {
    return FinalOrderRoomInfoDtoFromJSONTyped(json, false);
}

export function FinalOrderRoomInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinalOrderRoomInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'tariff': TariffInfoDtoFromJSON(json['tariff']),
        'checksum': json['checksum'],
        'roomTypeId': json['roomTypeId'],
    };
}

  export function FinalOrderRoomInfoDtoToJSON(json: any): FinalOrderRoomInfoDto {
      return FinalOrderRoomInfoDtoToJSONTyped(json, false);
  }

  export function FinalOrderRoomInfoDtoToJSONTyped(value?: FinalOrderRoomInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'tariff': TariffInfoDtoToJSON(value['tariff']),
        'checksum': value['checksum'],
        'roomTypeId': value['roomTypeId'],
    };
}

